import 'isomorphic-fetch';

declare const TNEW_RESOURCES_DOMAIN;

export class alertBar {
    constructor(public alertBarElement: any) {

        const ALERT_MESSAGE_ID = 'alert-bar';
        const ALERT_CANCEL_ID = 'alert-close';
        const SHOW_CLASS = 'alert-bar-active';

        let alertMessageElement = document.getElementById(ALERT_MESSAGE_ID);
        let alertCancelElement = document.getElementById(ALERT_CANCEL_ID);

        if (alertMessageElement && alertCancelElement) {
            window.addEventListener("DOMContentLoaded", setAlertMessageVisibility);
            alertCancelElement.addEventListener("click", cancelAlert)
        }

        function setAlertMessageVisibility() {
            fetch(TNEW_RESOURCES_DOMAIN + "/api/AlertMessage/ShouldShowMessage",
            {
                credentials: 'include',
            })
            .then(response => {
                if (response.ok) {
                    return response.json() as Promise<boolean>;
                }
                else {
                    // Failure case
                    console.log(response);
                }
            }).then(shouldShowMessage => {
                if (shouldShowMessage)
                    alertMessageElement.classList.add(SHOW_CLASS);
                    headerOffsetHandler();
            });
        }

        function cancelAlert() {
            fetch(TNEW_RESOURCES_DOMAIN + "/api/AlertMessage/CloseModal", {
                method: 'post',
                credentials: 'include',
            })
            .then(response => {
                if (response.ok) {
                    alertMessageElement.classList.remove(SHOW_CLASS);
                    headerOffsetHandler();
                    return response;
                }
                else {
                    // Failure case
                    console.log(response);
                }
            });
        }

        //  sets header offset
        function headerOffsetHandler() {
            let headerHeight = document.getElementById('site-header').getBoundingClientRect().height;

            document.getElementById("main").style.paddingTop = headerHeight + 'px';
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/alert.ts